import { h } from "preact";

import { makeStyles } from "@mui/styles";

const useStyles = makeStyles((theme) => ({
	root: {
		flexGrow: 1,
	},
	menuButton: {
		marginRight: theme.spacing(2),
	},
	title: {
		flexGrow: 1,
	},
}));

export default function Picto6() {
	const classes = useStyles();

	return (
		<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 42.17 42.17" width="47px">
			<g id="Calque_2" data-name="Calque 2">
				<g id="design">
					<path d="M32.8,0a9.37,9.37,0,1,1,0,18.74H9.37A9.37,9.37,0,0,1,9.37,0Zm0,1.87H9.37a7.5,7.5,0,0,0,0,15H32.8a7.5,7.5,0,0,0,0-15Zm0,1.88a5.62,5.62,0,1,1-5.62,5.62A5.64,5.64,0,0,1,32.8,3.75Zm0,1.87a3.75,3.75,0,1,0,3.75,3.75A3.74,3.74,0,0,0,32.8,5.62Zm0,17.81a9.37,9.37,0,1,1,0,18.74H9.37a9.37,9.37,0,0,1,0-18.74Zm0,1.87H9.37a7.5,7.5,0,0,0,0,15H32.8a7.5,7.5,0,1,0,0-15ZM9.37,27.18A5.62,5.62,0,1,1,3.75,32.8,5.62,5.62,0,0,1,9.37,27.18Zm0,1.87a3.75,3.75,0,1,0,3.75,3.75A3.74,3.74,0,0,0,9.37,29.05Z" />
				</g>
			</g>
		</svg>
	);
}
